export const provinces: Record<number, { name: string; fa: string }> = {
  "1": {
    name: "East Azerbaijan",
    fa: "آذربایجان شرقی",
  },
  "2": {
    name: "West Azerbaijan",
    fa: "آذربایجان غربی",
  },
  "3": {
    name: "Ardabil",
    fa: "اردبیل",
  },
  "4": {
    name: "Isfahan",
    fa: "اصفهان",
  },
  "5": {
    name: "Ilam",
    fa: "ایلام",
  },
  "6": {
    name: "Bushehr",
    fa: "بوشهر",
  },
  "7": {
    name: "Tehran",
    fa: "تهران",
  },
  "8": {
    name: "Chaharmahal and Bakhtiari",
    fa: "چهارمحال و بختیاری",
  },
  "10": {
    name: "Khuzestan",
    fa: "خوزستان",
  },
  "11": {
    name: "Zanjan",
    fa: "زنجان",
  },
  "12": {
    name: "Semnan",
    fa: "سمنان",
  },
  "13": {
    name: "Sistan and Baluchestan",
    fa: "سیستان و بلوچستان",
  },
  "14": {
    name: "Fars",
    fa: "فارس",
  },
  "15": {
    name: "Kerman",
    fa: "کرمان",
  },
  "16": {
    name: "Kurdistan",
    fa: "کردستان",
  },
  "17": {
    name: "Kermanshah",
    fa: "کرمانشاه",
  },
  "18": {
    name: "Kohgiluyeh and Boyer-Ahmad",
    fa: "کهگیلویه و بویر احمد",
  },
  "19": {
    name: "Gilan",
    fa: "گيلان",
  },
  "20": {
    name: "Lorestan",
    fa: "لرستان",
  },
  "21": {
    name: "Mazandaran",
    fa: "مازندران",
  },
  "22": {
    name: "Markazi",
    fa: "مرکزی",
  },
  "23": {
    name: "Hormozgan",
    fa: "هرمزگان",
  },
  "24": {
    name: "Hamadan",
    fa: "همدان",
  },
  "25": {
    name: "Yazd",
    fa: "یزد",
  },
  "26": {
    name: "Qom",
    fa: "قم",
  },
  "27": {
    name: "Golestan",
    fa: "گلستان",
  },
  "28": {
    name: "Qazvin",
    fa: "قزوین",
  },
  "29": {
    name: "South Khorasan",
    fa: "خراسان جنوبی",
  },
  "30": {
    name: "Razavi Khorasan",
    fa: "خراسان رضوی",
  },
  "31": {
    name: "North Khorasan",
    fa: "خراسان شمالی",
  },
  "32": {
    name: "Alborz",
    fa: "البرز",
  },
};
